module.exports = __webpack_public_path__ + "img/journal.93371f06.png";